module.exports = __webpack_public_path__ + "static/media/main-events-preview.2a9b9e53.jpg";